import { remove, removeBulkMile } from '../index';

export const deleteTracking = (data) => {
  return remove(`/tracking?userId=${data?.user?._id}&timesheetId=${data?._id}&firstday=${data?.firstday}&companyId=${data?.companyId}`);
};

export const deleteBulkTracking = (data) => {
  return removeBulkMile(`/revision/bulk`, data);
};
